module.exports = __webpack_public_path__ + "img/824.3fbe7f9b.png";